export const NetConfig = [
  {
    key: 'BSC',
    NetWorkName: 'BSC',
    logoURI: require('@/assets/tokenlogo/BNBnetwork.png'),
    Url: 'https://bsc-dataseed.binance.org',
    blocsUrl: 'https://bscscan.com/tx/',
    blocsHashUrl: 'https://bscscan.com/token/',
    swapConfig: {
      jackRouter: '0x6C6bcd70e9207a12dc960a7294ED8BA6D9C994ca',
      jackFactory: '0x1f4ee4FD5dF1b23B902Be60Be299dD6608Ff610E',
      weth: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    },
    chainId: "0x38",
    TokenBNB: {
      name: 'BNB',
      symbol: 'BNB',
      address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      chainId: 56,
      decimals: 18,
      logoURI: require('@/assets/tokenlogo/BNB.png'),
    }
  },
]
